<template>
  <v-dialog v-model="ackdialog" width="500px">
    <v-card class="overflow-hidden">
      <v-toolbar dark class="gradient-bg2" dense>
        <v-toolbar-title class="ml-n2">Select and Acknowledge</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class text dark @click="ackdialog = false">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-data-table
        class="mt-3"
        :headers="ackhead"
        hide-default-footer
        show-select
        v-model="selected"
        item-key="card_id"
        :items-per-page="40"
        :items="acklist"
        dense
      >
        <template
          v-slot:[`item.data-table-select`]="{ item, isSelected, select }"
        >
          <v-simple-checkbox
            :value="isSelected"
            :ripple="false"
            :readonly="item.status != 3"
            :disabled="item.status != 3"
            @input="select($event)"
          ></v-simple-checkbox>
        </template>
      </v-data-table>

      <v-card-actions>
        <v-row>
          <v-spacer />
          <v-btn
            class="mr-3 mt-2 white--text"
            @click="assignAcknowlede"
            color="black"
            >Acknowledge</v-btn
          >
        </v-row>
      </v-card-actions>
      <v-card-actions />
    </v-card>
  </v-dialog>
</template>

<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";
// import func from "../../../vue-temp/vue-editor-bridge";
export default {
  data: () => ({
    ackdialog: false,
    selected: [],
    singleSelect: true,
    acklist: [],

    ackhead: [
      {
        text: "List Of Proxy's",
        value: "proxy_number",
      },
    ],

    itemsProxy: {},
  }),

  methods: {
    async assignAcknowlede() {
      var sendArry = [];

      this.selected.forEach(function (ele) {
        sendArry.push(ele.card_id);
      });
      var inputData = {
        method_name: "CARDS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CARDUP",
          card_id: sendArry,
        },
      };

      var responseData = await apiCall(inputData);
      console.warn(responseData);
      this.$emit("backChild");
      this.$store.commit("snackbar/showMessage", {
        content: "Acknowledged Proxy Numbers",
        color: "green",
      });
      this.ackdialog = false;
    },
    async acknowledge() {
      //  console.log("this.itemsProxy.request_id", this.itemsProxy.request_id);
      var inputData = {
        method_name: "CARDS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETNUM",
          request_id: this.itemsProxy.request_id,
          status: "0",
        },
      };
      var responseData = await apiCall(inputData);
      this.acklist = responseData.data.data;

      this.selected = [];
      var self = this;

      self.acklist.forEach(function (ele) {
        if (ele.status != 3) {
          self.selected.push(ele);
        }
      });
      //   console.log("post ack", this.acklist);
    },
  },
};
</script>

<style></style>
